import { LazyLoadImage } from 'react-lazy-load-image-component';

import Arrow from '../../../assets/about/about-arrow.svg';
import BokehLeft from '../../../assets/about/about-section-1-bokeh-left.png';
import BokehRight from '../../../assets/about/about-section-1-bokeh-right.png';
import BokehAnimationBox from '../../../components/bokehAnimationBox/BokehAnimationBox';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import { ScrollAnimationType } from '../../../enums/scroll-animation-type.enum';

import styles from './AboutMainSection.module.scss';

const AboutMainSection = () => {
  return (
    <div className={styles['section']}>
      <ScrollInAnimationItem
        animationType={ScrollAnimationType.fadeIn}
        className={styles['bokeh-left-container']}
        delay="0.5s"
        threshold={0.3}
      >
        <div className="pulse-animation">
          <LazyLoadImage className={styles['bokeh-left']} src={BokehLeft} alt="" />
          <BokehAnimationBox secondary className={styles['bokeh-animation-box-left']} />
        </div>
      </ScrollInAnimationItem>
      <ScrollInAnimationItem delay="0.1s" threshold={0.3}>
        <h1 className={styles['caption']}>
          What is <br />
          <span>reality nft?</span>
        </h1>
      </ScrollInAnimationItem>
      <ScrollInAnimationItem delay="0.2s" threshold={0.3} animationType={ScrollAnimationType.slideInLeft}>
        <LazyLoadImage alt="" className={styles['arrow']} src={Arrow} />
      </ScrollInAnimationItem>
      <div className={styles['content']}>
        <ScrollInAnimationItem delay="0.3s" threshold={0.3}>
          <p className={styles['main-text']}>
            Reality NFT has created the true connection between real life and the Metaverse, where web2 and web3 users
            can co-exist. We are allowing users true ownership of their assets in games played by millions of players in
            the flagship mobile game Landlord GO. Each NFT corresponds to real-world locations, famous landmarks, most
            prominent cities, countries and generates utilities in royalties.
          </p>
        </ScrollInAnimationItem>
        <ScrollInAnimationItem delay="0.4s" threshold={0.1}>
          <p className={styles['hint']}>Be a part of the digital revolution!</p>
        </ScrollInAnimationItem>
      </div>
      <ScrollInAnimationItem
        animationType={ScrollAnimationType.fadeIn}
        className={styles['bokeh-right-container']}
        delay="0.5s"
        threshold={0.3}
      >
        <div className="pulse-animation">
          <LazyLoadImage className={styles['bokeh-right']} src={BokehRight} alt="" />
          <BokehAnimationBox secondary className={styles['bokeh-animation-box-right']} />
        </div>
      </ScrollInAnimationItem>
    </div>
  );
};

export default AboutMainSection;
